import { render, staticRenderFns } from "./output_price.vue?vue&type=template&id=13d5690c&scoped=true"
import script from "./output_price.vue?vue&type=script&lang=js"
export * from "./output_price.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d5690c",
  null
  
)

export default component.exports